import { useTranslation } from 'react-i18next';
import { useMembersQuery } from '@platform/state/api';
import { usePendingInvitations } from '../../shell/usePendingInvitations';
import { useWorkspaceMeta } from '../../shell/useWorkspaceMeta';

/**
 * Підзаголовок сторінок «Учасники» й «Запрошення» (прототип v4): «Простір · N учасників · M очікують» (до відповіді сервера — 0).
 */
export function useMembersSummary(ws: string): string {
  const { t } = useTranslation();
  const { workspace } = useWorkspaceMeta(ws);
  const { data: members } = useMembersQuery(ws, { skip: !ws });
  const pending = usePendingInvitations(ws) ?? 0;
  return [workspace?.name, members && t('shell.members', { count: members.length }), t('membersPage.pending', { count: pending })].filter(Boolean).join(' · ');
}
